export const ROUTE_PATHS = {
  index: 'index',
  dtcOverview: 'dtc/overview',
  dtcNew: 'dtc/new',
  dtcRecycling: 'dtc/recycling',
  errorMessageOverview: 'error-message/overview',
  errorMessageNew: 'error-message/new',
  errorMessageRecycling: 'error-message/recycling',
  swPartNumberOverview: 'sw-part-number/overview',
  swPartNumberRecycling: 'sw-part-number/recycling',
  signIn: 'sign-in',
  signInFailed: 'sign-in-failed',
  signedOut: 'signed-out',
  insufficientRights: 'insufficient-rights',
  import: 'import',
  errorCodeOverview: 'error-code/overview',
  errorCodeRecycling: 'error-code/recycling',
  errorCodeNew: 'error-code/new',
  importErrorCodes: 'import-error-codes',
  nwNumberOverview: 'nw-number/overview',
};
